import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { hashHistory } from 'react-router'
import Rowbox from '../Common/Rowbox'
import { DECORATION_SHOP_INFO, EDIT_STORE_PATH } from '@constant'
import style from './style.module.less'
import { POSITION_MAP } from '@components/LocalMerchant/SiDa/constant'
import { getMerchantInfo, isSiDaMember, isSiDaTeam } from '@util'
import { ctrlTextLen } from '@hlj/hlj-utils'
import Group from './Group'
import { Modal, Tooltip } from 'hljd'
import { SHOP_INFO_STATUS_MAP } from '@components/LocalMerchant/Decoration/constant'
import SanDaMember from './SanDaMember'

@observer
export default class extends Component {
  getStatus = () => {
    const { status } = getMerchantInfo()
    return SHOP_INFO_STATUS_MAP[String(status)]
  }

  handleClick = () => {
    if (this.props.store.mode == 'preview') {
      return
    }
    const { examine, is_opened_trade } = getMerchantInfo()
    // 店铺审核未通过或未交店铺服务费的不能编辑
    if (examine != 1 || !is_opened_trade) {
      return Modal.info({
        title: '店铺处于入驻审核阶段，不可编辑店铺信息'
      })
    }
    hashHistory.push(EDIT_STORE_PATH)
  }

  render() {
    if (isSiDaTeam()) {
      return <Group />
    }

    if (isSiDaMember()) {
      return <SanDaMember />
    }

    const {
      store: { promiseData }
    } = this.props
    const {
      des,
      working_seniority,
      position,
      logo_path,
      name,
      full_address,
      merchant_comment = {}
    } = promiseData
    const { score, total_good_count } = merchant_comment

    return (
      <Rowbox
        type={DECORATION_SHOP_INFO}
        store={this.props.store}
        style={{
          height: 112,
          padding: 16
        }}
        onClick={this.handleClick}
        status={this.getStatus()}
      >
        <div className={style['siyi-header']}>
          <img className={style.logo} src={logo_path} />
          <div>
            <div className={style.top}>
              <div className={style.name}>{name}</div>
              <div className={style.position}>
                从业{working_seniority}年{' '}
                {position ? `·${POSITION_MAP[position]}` : ''}
              </div>
            </div>

            <Tooltip title={des}>
              <div className={style.desc}>{ctrlTextLen(des, 19, '...')}</div>
            </Tooltip>

            <div className={style.bottom}>
              <div className={style['bottom-item']}>{full_address}</div>
              <div className={style['bottom-item']}>
                <b>{score}</b> 评分
              </div>
              <div className={style['bottom-item']}>
                <b>{total_good_count}</b> 好评数
              </div>
            </div>
          </div>
        </div>
      </Rowbox>
    )
  }
}
